import { Component } from '@angular/core';

@Component({
  selector:    'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls:   ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent {
  lastUpdated = 'August 2026';
  appName     = 'KinexOps';
  companyName = 'KinexOps Technologies';
  contactEmail = 'kinexopsinfo@gmail.com';
  websiteUrl  = 'https://kinexops.com';
}